import { SOCIAL_CHANNEL } from 'reference-resolvers/constants/CacheKeys';
//@ts-expect-error untyped
import createSimpleCachedReferenceResolver from 'reference-resolvers/lib/createSimpleCachedReferenceResolver';
import { getSocialChannels, createGetSocialChannels } from '../api/SocialApi';
import { Map as ImmutableMap } from 'immutable';
export const getSocialChannelReferenceResolver = options => {
  return createSimpleCachedReferenceResolver(Object.assign({
    cacheKey: SOCIAL_CHANNEL,
    createFetchData: createGetSocialChannels,
    fetchData: getSocialChannels,
    selectReferencesById: references => {
      const indexedById = {};
      references.forEach(item => {
        indexedById[item.get('id')] = item;
      });
      return ImmutableMap(indexedById);
    }
  }, options));
};
export default getSocialChannelReferenceResolver();